import { DEFAULT_ODOSCOPE_SORT_VALUE_KEY } from '~/config/defaultConfigs'

export enum OdoscopeSortQuery {
  PriceDesc = 'price-desc',
  PriceAsc = 'price-asc',
  LabelDesc = 'label-desc',
  LabelAsc = 'label-asc',
}

export enum OdoscopeSortName {
  PriceDesc = 'price_desc',
  PriceAsc = 'price_asc',
  LabelDesc = 'label_desc',
  LabelAsc = 'label_asc',
}

enum OdoscopeProductStandardSorting {
  Price = 'price',
  Label = 'label',
}

enum OdoscopeSortOrder {
  Ascending = 'asc',
  Descending = 'desc',
}

export interface OdoscopeSortValue {
  name: OdoscopeSortName
  query?: OdoscopeSortQuery
  by?: OdoscopeProductStandardSorting
  direction?: OdoscopeSortOrder
}

export const odoscopeSortingValues = {
  priceDesc: {
    by: OdoscopeProductStandardSorting.Price,
    direction: OdoscopeSortOrder.Descending,
    name: OdoscopeSortName.PriceDesc,
    query: OdoscopeSortQuery.PriceDesc,
  },
  priceAsc: {
    by: OdoscopeProductStandardSorting.Price,
    direction: OdoscopeSortOrder.Ascending,
    name: OdoscopeSortName.PriceAsc,
    query: OdoscopeSortQuery.PriceAsc,
  },
  labelDesc: {
    by: OdoscopeProductStandardSorting.Label,
    direction: OdoscopeSortOrder.Descending,
    name: OdoscopeSortName.LabelDesc,
    query: OdoscopeSortQuery.LabelDesc,
  },
  labelAsc: {
    by: OdoscopeProductStandardSorting.Label,
    direction: OdoscopeSortOrder.Ascending,
    name: OdoscopeSortName.LabelAsc,
    query: OdoscopeSortQuery.LabelAsc,
  },
}

export type OdoscopeSortingValueKey = keyof typeof odoscopeSortingValues

export const getOdoscopeSortByValue = (
  query: string,
  defaultSort?: OdoscopeSortingValueKey,
) => {
  switch (query) {
    case OdoscopeSortQuery.PriceDesc:
      return odoscopeSortingValues.priceDesc
    case OdoscopeSortQuery.PriceAsc:
      return odoscopeSortingValues.priceAsc
    case OdoscopeSortQuery.LabelDesc:
      return odoscopeSortingValues.labelDesc
    case OdoscopeSortQuery.LabelAsc:
      return odoscopeSortingValues.labelAsc
    default:
      return odoscopeSortingValues[
        defaultSort || DEFAULT_ODOSCOPE_SORT_VALUE_KEY
      ]
  }
}
